<template>
  <b-modal ref="driver-card-modal" @ok="driverCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.drivers.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.firstName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="firstName"
          :state="isFirstNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.lastName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="lastName"
          :state="isLastNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.patronymic"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="patronymic"
          :state="isPatronymicValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.note"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="note"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.cardId"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="cardId"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.isActive"
        label-for="input-horizontal"
      >
        <b-form-checkbox
            v-model="isActive"
            :value="1"
            :unchecked-value="0"
          >
          </b-form-checkbox>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.fuelDepo"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="fuelDepoId"
          :state="isFuelDepoValid"
          :options="fuelDepoOptions"
          style="font-size: 13px"
          @change="onFuelDepoChange"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.driversCompanyId"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="driversCompanyId"
          :state="isDriversCompanyIdValid"
          :options="driverCompaniesOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.drivers.tableColumns.technicalDeviceId"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="technicalDeviceId"
          :state="isTechnicalDeviceIdValid"
          :options="technicalDevicesOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { azkService } from "../../../../services";

export default {
  name: "CreateDriverPage",
  props: {
    fuelDepos: Array,
    drivers: Array,
    driverCompanies: Array,
    technicalDevices: Array,
    globalDriverCompanies: Array,
    fuelTanks: Array,
  },
  components: {},
  data() {
    return {
      fuelDepoOptions: [],
      driverCompaniesOptions: [],
      technicalDevicesOptions: [],

      firstName: null,
      lastName: null,
      patronymic: null,
      note: null,
      cardId: null,
      isActive: null,
      driversCompanyId: null,
      fuelDepoId: null,
      technicalDeviceId: null,
     
      isFirstNameValid: null,
      isLastNameValid: null,
      isPatronymicValid: null,
      isDriversCompanyIdValid: null,
      isFuelDepoValid: null,
      isTechnicalDeviceIdValid: null
    };
  },
  methods: {
    open() {
      this.firstName = null;
      this.lastName = null;
      this.patronymic = null;
      this.note = null;
      this.cardId = null;
      this.isActive = 1;
      this.driversCompanyId = null;
      this.fuelDepoId = null;
      this.technicalDeviceId = null;
      
      this.isFirstNameValid = null;
      this.isLastNameValid = null;
      this.isPatronymicValid = null;
      this.isDriversCompanyIdValid = null;
      this.isFuelDepoValid = null;
      this.isTechnicalDeviceIdValid = null;
      this.fuelDepoOptions = [];
      this.driverCompaniesOptions = [];
      this.technicalDevicesOptions = [];

      for (let i = 0; i < this.fuelDepos.length; i++) {
        this.fuelDepoOptions.push({
          value: this.fuelDepos[i].id,
          text: this.fuelDepos[i].name,
        });
      }

      this.$refs["driver-card-modal"].show();
    },
    onFuelDepoChange(value) {
        this.driverCompaniesOptions = [];
        
        for (let i = 0; i < this.driverCompanies.length; i++) {
            if (this.driverCompanies[i].fuelDepoId == value) {
                this.driverCompaniesOptions.push({
                    value: `${this.driverCompanies[i].id}-local`,
                    text: this.driverCompanies[i].companyName,
                });
            }
        }

        for (let i = 0; i < this.globalDriverCompanies.length; i++) {
          this.driverCompaniesOptions.push({
            value: `${this.globalDriverCompanies[i].id}-global`,
            text: this.globalDriverCompanies[i].unit,
          });
        }

        this.technicalDevicesOptions = [];
        
        for (let i = 0; i < this.technicalDevices.length; i++) {
            if (this.technicalDevices[i].fuelDepoId == value) {
                this.technicalDevicesOptions.push({
                    value: this.technicalDevices[i].id,
                    text: this.technicalDevices[i].nameTechnicalDevice,
                });
            }
        }
    },
    validate() {
      let isValid = true;

      if (!this.firstName) {
        this.isFirstNameValid = false;
        isValid = false;
      } else {
        this.isFirstNameValid = null;
      }

      if (!this.lastName) {
        this.isLastNameValid = false;
        isValid = false;
      } else {
        this.isLastNameValid = null;
      }

      if (!this.patronymic) {
        this.isPatronymicValid = false;
        isValid = false;
      } else {
        this.isPatronymicValid = null;
      }
      
      if (!this.fuelDepoId) {
        this.isFuelDepoValid = false;
        isValid = false;
      } else {
        this.isFuelDepoValid = null;
      }

      if (!this.driversCompanyId) {
        this.isDriversCompanyIdValid = false;
        isValid = false;
      } else {
        this.isDriversCompanyIdValid = null;
      }

      if (!this.technicalDeviceId) {
        this.isTechnicalDeviceIdValid = false;
        isValid = false;
      } else {
        this.isTechnicalDeviceIdValid = null;
      }


      return isValid;
    },
    async driverCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      const fuelDepoId = parseInt(this.fuelDepoId);
      const fuelDepo = this.fuelTanks.find(x => x.fuelDepoId == fuelDepoId);

      const technicalDevice = this.technicalDevices.find(x => x.id == this.technicalDeviceId);
      
      const driverCard = {
        firstName: this.firstName,
        lastName: this.lastName,
        patronymic: this.patronymic,
        note: this.note,
        cardId: this.cardId,
        isActive: this.isActive,
        clientId: fuelDepo.clientId,
        technicalDeviceId: technicalDevice.technicalDeviceId,
        fuelDepoId: fuelDepoId,
        driversCompanyId: 0
      };

      if (this.driversCompanyId.includes('-local')) {
        const driversCompanyId = parseInt(this.driversCompanyId.replace('-local', ''));
        const company = this.driverCompanies.find(x => x.id == driversCompanyId);

        driverCard.driversCompanyId = company.companyId;
      } else {
        const driversCompanyId = parseInt(this.driversCompanyId.replace('-global', ''));
        const globalDriverCompany = this.globalDriverCompanies.find(x => x.id == driversCompanyId);
        driverCard.globalCompanyId = globalDriverCompany.id;
      }

      const createDriverResponse = await azkService.createDriver(driverCard);

      if (
        createDriverResponse.isSuccess &&
        createDriverResponse.data &&
        createDriverResponse.data.countInsertedRows == 1
      ) {
        this.$emit("driverCreatedSuccessEvent", this.driver);
      } else {
        this.$emit("driverCreatedFailEvent");
      }
    },
  },
};
</script>
